export interface SelectOption {
  value: string;
  label: string;
}

export interface WorkflowNextAction {
  title: string;
  detail: string;
}

export const SOURCE_OPTIONS: SelectOption[] = [
  { value: "web", label: "Web" },
  { value: "referral", label: "Referral" },
  { value: "walk in", label: "Walk in" },
  { value: "social", label: "Social" },
];

export const CASE_STAGE_BADGE_BY_STATUS: Record<string, string> = {
  ACTIVE: "badge-blue",
  PENDING: "badge-amber",
  DONE: "badge-green",
  BLOCKED: "badge-red",
};

export const NEXT_ACTION_BY_CASE_LIFECYCLE_STATUS: Record<string, WorkflowNextAction> = {
  document_collection: {
    title: "Drive document completion",
    detail: "Review missing items and ensure the document set is complete and verified.",
  },
  application_preparation: {
    title: "Prepare application package",
    detail: "Complete drafting and assembly tasks for submission readiness.",
  },
  internal_review: {
    title: "Run internal quality review",
    detail: "Resolve internal review comments before sending to client review.",
  },
  client_review: {
    title: "Collect client sign-off",
    detail: "Address client feedback and secure final approval to submit.",
  },
  submission: {
    title: "Track submitted application",
    detail: "Confirm submission evidence and monitor post-submission tasks.",
  },
  follow_up_and_rfi: {
    title: "Handle follow-ups and RFIs",
    detail: "Coordinate responses quickly to avoid delays in decision timelines.",
  },
  decision: {
    title: "Close decision actions",
    detail: "Record decision outcome and complete closure or next-step planning.",
  },
  closure: {
    title: "Case closed",
    detail: "No active workflow actions remain on this case.",
  },
};
